import { VerticalLanding, LandingConfig } from "./components/VerticalLanding";

// NuPlay Fashion — Mira, a 4-desk care crew for a premium apparel brand. The demo's
// spine is the LOYALTY TIER: the same refund question gets a different promise on
// Icon than it does on Member, and the picker ships the matched pair so a stranger
// can run the contrast without being told what to say.

const START = "/nurix-experience/experience?agent=nuplay-fashion&persona=fsh_FSH-1001&query=refund-status&channel=web";

const CONFIG: LandingConfig = {
  startHref: START,
  mark: { initials: "NF", gradient: "linear-gradient(135deg, #E11D74 0%, #7C1D5F 100%)" },
  brandName: "NuPlay Fashion",
  brandTagline: "Mira · Customer Care",
  eyebrow: "Retail — apparel care",
  headline: "One refund question,",
  headlineAccent: "two very different answers.",
  intro: (
    <>
      Meet <span className="font-semibold" style={{ color: "var(--nx-text-1)" }}>Mira</span>, NuPlay Fashion's care associate. Orders and delivery,
      returns and complaints, styling and loyalty — four desks behind one voice. Ask an Icon member where her refund is, then ask a Member the
      same thing, and listen to the tier decide the answer.
    </>
  ),
  features: [
    {
      gradient: "from-[#E11D74] to-[#9D174D]",
      icon: (
        <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
          <path d="M12 2l8 4v6c0 5-3.4 8.6-8 10-4.6-1.4-8-5-8-10V6z" /><path d="M9 12l2 2 4-4" />
        </svg>
      ),
      title: "The tier sets the promise, not the mood",
      desc: "Icon clears a refund on the call and gets a stylist callback. Insider gets three to five days. Member gets five to seven and no exception, said warmly and without wobbling.",
    },
    {
      gradient: "from-[#2582EB] to-[#1D6BD8]",
      icon: (
        <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
          <rect x="3" y="3" width="7" height="7" rx="1.5" /><rect x="14" y="3" width="7" height="7" rx="1.5" />
          <rect x="3" y="14" width="7" height="7" rx="1.5" /><rect x="14" y="14" width="7" height="7" rx="1.5" />
        </svg>
      ),
      title: "Four desks, no handoff the caller can hear",
      desc: "Orders, returns, complaints and styling are separate agents with separate tools. The routing happens mid-sentence — the caller never repeats an order number.",
    },
    {
      gradient: "from-[#34d399] to-[#059669]",
      icon: (
        <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
          <ellipse cx="12" cy="5" rx="9" ry="3" /><path d="M3 5v14c0 1.7 4 3 9 3s9-1.3 9-3V5" /><path d="M3 12c0 1.7 4 3 9 3s9-1.3 9-3" />
        </svg>
      ),
      title: "Every number read off a live database",
      desc: "Orders, returns, pickup holds and the loyalty policy all come from Supabase on the call. Nothing on this screen is scripted — change the row and the answer changes.",
    },
  ],
  card: {
    agentLine: "Mira — Customer Care",
    blurb: (
      <>
        Start as <span className="font-semibold" style={{ color: "var(--nx-text-1)" }}>Priya Nair</span>, an Icon member chasing a refund that has
        not landed yet. Then run the same call as Tom Rivera on Member and hear the timeline change. No account needed.
      </>
    ),
    rows: [
      { label: "Name", value: "Priya Nair" },
      { label: "Tier", value: "Icon" },
      { label: "Issue", value: "Refund not received" },
    ],
    footnote: "No account required · Live tier-aware call",
  },
  footerLine: "NuPlay Fashion — apparel customer-care demo",
};

export default function FashionLandingPage() {
  return <VerticalLanding config={CONFIG} />;
}
